import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import getDate from 'date-fns/getDate'
import { OpenStoreCalendarCell } from 'components/Calendar/index'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { StoreCalendarType } from 'types/storeCalendar'
import { dateToString, isHolidayOfStore } from 'lib/helper'
import { getSpecialHolidays } from 'reducks/calendar/selectors'
import { getOrders } from 'reducks/checkout/selectors'
import { OrderType } from 'types/checkout'
import { getHolidays } from 'reducks/store/selectors'
import isSameDay from 'date-fns/isSameDay'

type Props = {
  activeDate: Date | undefined
  selectDate: (date: Date | undefined) => void
  storeCalendars: StoreCalendarType[]
  row: Date[]
}

const OpenStoreCalendarRow: FC<Props> = (props) => {
  const { activeDate, selectDate, storeCalendars, row } = props

  const holidays = useSelector((state: State) => getHolidays(state))
  const specialHolidays = useSelector((state: State) => getSpecialHolidays(state))
  const orders: OrderType[] = useSelector((state: State) => getOrders(state))

  return (
    <tr className={styles.table__row}>
      {row.map((date) => {
        const isActive = activeDate ? isSameDay(date, activeDate) : false
        const isRegularClosed = isHolidayOfStore(date, holidays, specialHolidays)
        const isOrdered = orders.some((order) => order.date === dateToString(date))
        const storeCalendar = storeCalendars.find((storeCalendar) => {
          return storeCalendar.date === dateToString(date)
        })
        const isSpecialHoliday = specialHolidays.some((specialHoliday) => specialHoliday.date === dateToString(date))
        const isTemporaryClosed = storeCalendar ? storeCalendar.status === 'close' : false
        const isTemporaryOpen = storeCalendar ? storeCalendar.status === 'open' : false

        return (
          <OpenStoreCalendarCell
            key={getDate(date)}
            date={date}
            isActive={isActive}
            isRegularClosed={isRegularClosed}
            isOrdered={isOrdered}
            isSpecialHoliday={isSpecialHoliday}
            isTemporaryClosed={isTemporaryClosed}
            isTemporaryOpen={isTemporaryOpen}
            selectDate={selectDate}
          />
        )
      })}
    </tr>
  )
}

export default OpenStoreCalendarRow
